module.exports = __webpack_public_path__ + "assets/img/btn-login-sumbit@2x.be27dda0.png";